import React from 'react';
import { PositionsTableSkeleton } from './components/PositionsTableSkeleton';
import { EmptyState } from '../../../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';

interface PositionsTableEmptyProps {
  isEmbeddedMobile: boolean;
}

export const PositionsTableEmpty = ({ isEmbeddedMobile }: PositionsTableEmptyProps) => {
  return (
    <PositionsTableSkeleton isEmbeddedMobile={isEmbeddedMobile}>
      <Box p="56" bg="bg">
        <EmptyState />
      </Box>
    </PositionsTableSkeleton>
  );
};
